import Accordion from "./modules/Accordion";
import Footer from "./modules/Footer";
import Header from "./modules/Header";
import MobileNav from "./modules/MobileNav";
import Share from "./modules/Share";
import Animations from "./modules/Animations";
import ContactStrip from "./modules/ContactStrip";
import LanguageSwitcher from "./modules/LanguageSwitcher";
import { LinksSlider } from "./modules/LinksSlider";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

const animations = new Animations();

const initApp = () => {
	console.log("======== DOM loaded successfully ========");
	console.log("%cCODEPLUS", "color: #113B37; font-size: 1.5rem;");

	// Header
	const header = document.querySelector("#header");
	new Header(header);

	// Language Switcher
	const languageSwitchers = document.querySelectorAll("#language-switcher");
	languageSwitchers.forEach((switcher) => switcher && new LanguageSwitcher(switcher));

	// Footer Nav Items
	const footer = document.getElementById("footer");
	new Footer(footer);

	// Areas Link Slider
	const areasLinks = document.querySelector(".swiper.areas__links");
	const serviceLinks = document.querySelector(".swiper.service__links");
	areasLinks && new LinksSlider(areasLinks);
	serviceLinks && new LinksSlider(serviceLinks);

	// Areas Accordion
	const areasAccordion = document.getElementById("areasAccordion");
	const serviceAccordion = document.getElementById("serviceAccordion");
	areasAccordion && new Accordion(areasAccordion);
	serviceAccordion && new Accordion(serviceAccordion);

	// Share
	const shareWrapper = document.querySelectorAll("[js-share-module]");
	shareWrapper.length > 0 && shareWrapper.forEach((item) => new Share(item));

	// Mobile Navigation
	const mobileNav = document.querySelector("#mobileNav");
	new MobileNav(mobileNav);

	// Contact Strip
	const contactStrip = document.querySelector(".contact-strip.--mobile");
	contactStrip && new ContactStrip(contactStrip);

	// Contact Form
	//	const form = document.querySelector(".form");
	//form && new Form(form);
	animations.init();

	// Links Slider Intersection Observer
	const setActiveLink = (target) => {
		const linkId = target.id;
		const link = document.querySelector(`[href="#${linkId}"]`);
		link.classList.add("active");
	};

	const removeActiveLink = (target) => {
		const linkId = target.id;
		const link = document.querySelector(`[href="#${linkId}"]`);
		link.classList.remove("active");
	};

	ScrollTrigger.batch("[js-link-slider-item]", {
		start: "top +=20%",
		end: "bottom +=20%",
		// markers: true,
		onEnter: (targets) => setActiveLink(targets[0]),
		onEnterBack: (targets) => setActiveLink(targets[0]),
		onLeave: (targets) => removeActiveLink(targets[0]),
		onLeaveBack: (targets) => removeActiveLink(targets[0]),
	});
};

if (document.readyState === "loading") {
	animations.setInitialStyles();
	// Loading hasn't finished yet
	document.addEventListener("DOMContentLoaded", initApp);
} else {
	// `DOMContentLoaded` has already fired
	initApp();
}
